// 観葉植物: 鉢＋葉（四角で表現）
import { Box } from '@react-three/drei'

export default function PlantMesh({ width, height, depth, position, color, isSelected }) {
    const potHeight = height * 0.3
    // 鉢のサイズ
    const potSize = Math.min(width, depth) * 0.6
    // 幹の高さ（鉢の上から上端まで）
    const trunkHeight = height - potHeight
    // 幹の太さ（小さい方に合わせる）
    const trunkThickness = Math.min(width, depth) * 0.12

    // 7段の葉（下から上へ順々に小さくなる）
    // 一番下の葉は鉢と同じ（width, depth）
    // 上に行くほど小さくなる（比率で指定）
    const leafRatios = [1.0, 0.9, 0.8, 0.7, 0.6, 0.55, 0.5]  // 葉1〜葉7の比率
    const leaf1W = width * leafRatios[0], leaf1D = depth * leafRatios[0]
    const leaf2W = width * leafRatios[1], leaf2D = depth * leafRatios[1]
    const leaf3W = width * leafRatios[2], leaf3D = depth * leafRatios[2]
    const leaf4W = width * leafRatios[3], leaf4D = depth * leafRatios[3]
    const leaf5W = width * leafRatios[4], leaf5D = depth * leafRatios[4]
    const leaf6W = width * leafRatios[5], leaf6D = depth * leafRatios[5]
    const leaf7W = width * leafRatios[6], leaf7D = depth * leafRatios[6]

    const leafHeight = height * 0.02  // 各葉の高さ（heightに依存、固定比率）
    const leafSpacing = (height - potHeight) / 7  // 葉の間隔（高さを7等分）

    // 葉の位置（一番上は上端に接触）
    const leaf7Y = position[1] + height / 2 - leafHeight / 2
    const leaf6Y = leaf7Y - leafSpacing
    const leaf5Y = leaf6Y - leafSpacing
    const leaf4Y = leaf5Y - leafSpacing
    const leaf3Y = leaf4Y - leafSpacing
    const leaf2Y = leaf3Y - leafSpacing
    const leaf1Y = leaf2Y - leafSpacing

    return (
        <group>
            {/* 鉢 */}
            <Box args={[width, potHeight, depth]} position={[0, position[1] - height / 2 + potHeight / 2, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.6} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 土 */}
            <Box args={[width * 0.9, potHeight * 0.1, depth * 0.9]} position={[0, position[1] - height / 2 + potHeight - potHeight * 0.1, 0]}>
                <meshStandardMaterial color={color} metalness={0.1} roughness={0.8} />
            </Box>

            {/* 幹 */}
            <Box args={[trunkThickness, trunkHeight, trunkThickness]} position={[0, position[1] - height / 2 + potHeight + trunkHeight / 2, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.6} />
            </Box>

            {/* 葉1（大、一番下） */}
            <Box args={[leaf1W, leafHeight, leaf1D]} position={[0, leaf1Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉2 */}
            <Box args={[leaf2W, leafHeight, leaf2D]} position={[0, leaf2Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉3 */}
            <Box args={[leaf3W, leafHeight, leaf3D]} position={[0, leaf3Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉4 */}
            <Box args={[leaf4W, leafHeight, leaf4D]} position={[0, leaf4Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉5 */}
            <Box args={[leaf5W, leafHeight, leaf5D]} position={[0, leaf5Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉6 */}
            <Box args={[leaf6W, leafHeight, leaf6D]} position={[0, leaf6Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 葉7（小、一番上） */}
            <Box args={[leaf7W, leafHeight, leaf7D]} position={[0, leaf7Y, 0]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 鉢 */}
            <Box args={[width, potHeight, depth]} position={[0, position[1] - height / 2 + potHeight / 2, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 幹 */}
            <Box args={[trunkThickness, trunkHeight, trunkThickness]} position={[0, position[1] - height / 2 + potHeight + trunkHeight / 2, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 各葉 */}
            <Box args={[leaf1W, leafHeight, leaf1D]} position={[0, leaf1Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf2W, leafHeight, leaf2D]} position={[0, leaf2Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf3W, leafHeight, leaf3D]} position={[0, leaf3Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf4W, leafHeight, leaf4D]} position={[0, leaf4Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf5W, leafHeight, leaf5D]} position={[0, leaf5Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf6W, leafHeight, leaf6D]} position={[0, leaf6Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>
            <Box args={[leaf7W, leafHeight, leaf7D]} position={[0, leaf7Y, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
